

export default [
  {
    path: '/subject-cores',
    name: 'subject-core',
    meta: { requiresAuth: true },
    component: () => import('@/pages/subject-core/index.vue'),
  }
]
